/* eslint-disable @typescript-eslint/no-explicit-any */
import { styleFn, variant } from 'styled-system'
import { themeGet } from '@styled-system/theme-get'
// ES-Lint disables
// prop types vary between usages
// abstracting to a utility to avoid duplication in component declarations

export const textStyle: styleFn = (props: any) => variant({
  prop: 'textStyle',
  variants: themeGet('textStyles')(props)
})

export const buttonSizes: styleFn = (props: any) => variant({
  prop: 'size',
  variants: themeGet('buttonSizes')(props)
})

export const buttons: styleFn = (props: any) => variant({
  prop: '$variant',
  variants: themeGet('buttons')(props)
})

export const texts: styleFn = (props: any) => variant({
  prop: '$variant',
  variants: themeGet('texts')(props)
})

export const inputs: styleFn = (props: any) => variant({
  prop: '$variant',
  variants: themeGet('inputs')(props)
})

export const dropdowns: styleFn = (props: any) => variant({
  prop: '$variant',
  variants: themeGet('dropdowns')(props)
})

export const checkboxes: styleFn = (props: any) => variant({
  prop: '$variant',
  variants: themeGet('checkboxes')(props)
})

export const radios: styleFn = (props: any) => variant({
  prop: '$variant',
  variants: themeGet('radios')(props)
})
